export default function() {
  this.attachFile = null;
  this.attachFilePreview = null;
  if (!this.attachFile) {
    this.$refs.attachFile.value = "";
  }
}
